import React from "react";
import styled from "styled-components";
import Icon from "../../shared/components/icon";

const ContactUs = styled.footer`
  background-color: #f8f8f8;
  width: 100%;
  font-size: 1rem;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
`;

const FooterLinks = styled.footer`
  padding-top: 2rem;
  background-color: #333;
  padding-bottom: 1.5rem;
`;

const Divider = styled.hr`
  border-color: #505050;
`;

const ColumnHeader = styled.div`
  color: #d9d9d9;
  font-weight: 700;
  margin-bottom: 12px;
`;

const Column = styled.div`
  width: 50%;
  display: inline-flex;
  flex-direction: column;

  a {
    display: flex;
    color: #d9d9d9;
    font-weight: 500;
    margin: 6px 0;
  }
`;

function Footer() {
  return (
    <div>
      <ContactUs className="inner-wrapper">
        <p className="bold">Contact Us</p>
        <p>Help with registration or login: </p>
        <p className="bold">1 (800) 853-2713</p>
      </ContactUs>

      <FooterLinks className="inner-wrapper">
        <ColumnHeader>© Cigna. All rights reserved</ColumnHeader>
        <Column>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/privacyinformation/"
          >
            Privacy
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.entrust.net/customer/profile.cfm?domain=my.cigna.com&lang=en"
          >
            Security <Icon type="external-link" size={20} />
          </a>
        </Column>
        <Column>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/legaldisclaimer/"
          >
            Legal Disclaimer
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/accessibility"
          >
            Accessibility <Icon type="external-link" size={20} />
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/web-nondiscrimination-notice.pdf"
          >
            Nondiscrimination Notice
          </a>
        </Column>

        <Divider></Divider>

        <ColumnHeader>Language Assistance</ColumnHeader>
        <Column>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=spanish"
          >
            Español
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=chinese"
          >
            中文
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=tagalong"
          >
            Tagalog
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=russian"
          >
            Русский
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=french"
          >
            Français
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=portuguese"
          >
            Português
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=italian"
          >
            Italiano
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=german"
          >
            Deutsch
          </a>
        </Column>
        <Column>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=vietnamese"
          >
            Tiếng Việt
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=korean"
          >
            한국어
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=arabic"
          >
            العربية
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=french-creole"
          >
            Kreyòl
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=polish"
          >
            Polski
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=japanese"
          >
            日本語
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf#nameddest=persian"
          >
            فارسی
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cigna.com/static/www-cigna-com/docs/language-assistance/multi-language-interpreter-services.pdf"
          >
            More...
          </a>
        </Column>
      </FooterLinks>
    </div>
  );
}

export default Footer;
